import { GetApiUploadedFilesApiResponse } from "src/app/services/api.generated";
import { ColumnModes, ColumnType } from "src/types/genericTable.types";
import { ActionButtonModes } from "src/types/actionButton.types";
import { ActionModes } from "src/types/actionItems.types";
import theme from "src/configs/theme/theme";
import { Delete, Edit } from "@mui/icons-material";

const colors = new Map<string, string>([
  ["ناتمام", theme.palette.warning.light],
  ["تکمیل شده", theme.palette.success.main],
]);

export const ChannelFileData: ColumnType<any>[] = [
  { id: "title", label: "عنوان", type: ColumnModes.DATA, chip: false, color: new Map() },
  { id: "description", label: "توضیحات", type: ColumnModes.DATA, chip: false, color: new Map() },
  { id: "createdAt", label: "تاریخ ثبت", type: ColumnModes.DATA, chip: false, color: new Map() },
  { id: "action", label: "عملیات", type: ColumnModes.DATA, chip: false, color: new Map() },
  
];

